import React from "react";

const BackgroundCheckProcess = () => {
  return (
    <div>
      <h6 className="fw-bold mb-3">Information:</h6>
      <ul
        className="ps-3 mb-0"
        style={{ lineHeight: "1.9", listStyle: "disc" }}
      >
        <li>Address.</li>

        <li>
          We will perform address verification by sending you a link for
          latitude longitude / address proof document (Instructions will be in
          the email/sms we send you) -In case the above option cannot be done
          then as per customer requirements we will proceed with option below:-
        </li>

        <li className="list-unstyled mt-3">
          <div className="table-responsive">
            <table
              className="table table-bordered align-middle mb-0"
              style={{
                borderColor: "#999",
                fontSize: "14px",
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      width: "34%",
                      background: "#f8f8f8",
                      fontWeight: "600",
                    }}
                  >
                    Site Visit
                  </th>

                  <th
                    style={{
                      width: "33%",
                      background: "#f8f8f8",
                      fontWeight: "600",
                    }}
                  >
                    Telephonic
                  </th>

                  <th
                    style={{
                      width: "33%",
                      background: "#f8f8f8",
                      fontWeight: "600",
                    }}
                  >
                    Speed Post
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  {/* SITE VISIT */}
                  <td style={{ verticalAlign: "top" }}>
                    <ul
                      className="ps-3 mb-0"
                      style={{
                        lineHeight: "1.8",
                        listStyleType: "disc",
                      }}
                    >
                      <li>
                        In case of site visit verification for address a field
                        agent will be dispatched from Aupertz Services Private
                        Limited or our partner company. It is FREE, and no fees
                        are payable to the field executive during address
                        verification.
                      </li>

                      <li>
                        Do not provide verification over the phone to the field
                        agent. They need to visit you, collect documents, take
                        outside home pictures and you can help them with
                        directions only.
                      </li>

                      <li>
                        If you find issues regarding behavior/asking for money
                        you are welcome to write us at
                        candidatesupport@aupertz.co.in
                      </li>
                    </ul>
                  </td>

                  {/* TELEPHONIC */}
                  <td style={{ verticalAlign: "top" }}>
                    <ul
                      className="ps-3 mb-0"
                      style={{
                        lineHeight: "1.8",
                        listStyleType: "disc",
                      }}
                    >
                      <li>
                        In case of telephonic verification we will confirm the
                        address only and no documents will be required to be
                        sent.
                      </li>
                    </ul>
                  </td>

                  {/* SPEED POST */}
                  <td style={{ verticalAlign: "top" }}>
                    <ul
                      className="ps-3 mb-0"
                      style={{
                        lineHeight: "1.8",
                        listStyleType: "disc",
                      }}
                    >
                      <li>
                        In case of postal they will ask you for the code sent on
                        the letter over the phone.
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </li>

        <li>Employement</li>
        <p>
          We will contact your previous employers to check your employment
          details such as designations held, remuneration, duration of
          employment and any work related issues.
        </p>

        <li>UAN</li>
        <p>
          You will receive a link for UAN verification. You are required to
          enter your UAN passbook credentials to authorise the required data
          fetch. We will only fetch the name of the company, date of joining and
          date of reliving details.
        </p>

        <li>Reference</li>
        <p>
          We may call/send email to your professional or personal reference at
          the contact number (mentioned under"Reference") in the form submitted.
        </p>

        <li>Drug</li>
        <p>
          You will receive a link to schedule the drug test on your email/sms.
          You can choose your desired option of Lab Visit / Home Collection / or
          online kit delivery. For Drug testing you are required to provide
          urine sample with your employee ID and date of birth. Mouth Swab based
          testing will be introduced soon.
        </p>
      </ul>
    </div>
  );
};

export default BackgroundCheckProcess;
